export default __webpack_public_path__ + "static/media/button_on.02c4cd70.svg";